import { useFormikContext } from "formik";
import {
  DatePickerField,
  DisplayFormErrors,
  DrawerFooterContent,
  InputField,
  InputNumberField,
  SelectField,
  useCultures,
  VerticalForm,
} from "melco-shared-logic";
import { Button, Row, Title } from "melco-ui";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

import { useState } from "react";
import { CreateMachineLicensesFormValueType } from "./CreateMachineLicensesForm";
import dayjs from "dayjs";
import { useRolesContext } from "../../../../../hooks/roles/useRolesContext";
import { DropDownValueLabelObj } from "../../../../../helper/commonHelper";

const AlertWrapper = styled.div`
  margin-top: 25px;
`;

type DisplayCreateMachineLicensesFormProps = {
  machineLicensesFormValues?: CreateMachineLicensesFormValueType;
  machineLicensesDisplayValues?: any;
  callback: (v: any) => any;
};

export const DisplayCreateMachineLicensesForm: React.FC<
  DisplayCreateMachineLicensesFormProps
> = ({ machineLicensesDisplayValues, machineLicensesFormValues, callback }) => {
  const { t } = useTranslation();
  const { submitForm, setFieldValue } = useFormikContext();
  const { cultures } = useCultures();



  const [createConfirmDetailsToDisplay, setCreateConfirmDetailsToDisplay] =
    useState(machineLicensesDisplayValues);



  const { roles } = useRolesContext();

  let createAccessFilterListArray =
    roles?.VIRTUAL_SECURITY_GENERATE_ACCESS_LIST_FILTER_LIST?.toString()?.split(
      ","
    ) ?? [];
  createAccessFilterListArray.map((value) => value.trim());



  const onClickNext = () => {
    callback(createConfirmDetailsToDisplay);
    submitForm();
  };

  const callBackForLanguage = (v: any, obj: any) => {

    setCreateConfirmDetailsToDisplay({
      ...createConfirmDetailsToDisplay,
      language: obj.label,
      languageText: obj.label
    });
  };

  return (
    <>
      <div>
        <Title level={4}>{t("machinelicenses.create.title")}</Title>
        <VerticalForm>
          <AlertWrapper>
            <DisplayFormErrors />
          </AlertWrapper>
          {/* <InputField
            name="melco_customer_id"
            label={t("machinelicenses.create.form.melco_customer_id")}
          /> */}
          <InputField
            name="email_address"
            label={t("machinelicenses.create.form.email")}
            info={t("machinelicenses.create.form.email_info")}
          />
          <InputField
            name="license_key"
            label={t("machinelicenses.create.form.license_key")}
            info={
              t("machinelicenses.create.form.license_key_info")
            }
          />

          <InputNumberField
            name="number_of_machines"
            label={t("machinelicenses.create.form.number_of_machines")}
            min={0}
            style={{ width: "100%" }}
          />

          {/* <InputField
            name="number_of_machines"
            label={t("machinelicenses.create.form.number_of_machines")}
          /> */}
          <SelectField
            name="sub_type"
            label={t("machinelicenses.create.form.subscription_code")}
            options={[

              { label: t("machinelicenses.create.form.monthly"), value: "MONTHLY" },
              { label: t("machinelicenses.create.form.yearly"), value: "YEARLY" },
            ]}
          />

          <DatePickerField
            label={t("machinelicenses.create.form.subscription_start_date")}
            // info={t("machinelicenses.create.form.subscription_start_date_info")}
            name="sub_started_on"
            disabledDate={(current) =>
              !!current && current.isBefore(dayjs().startOf("day"))
            }
            onChange={(date, dateString) => {
              setFieldValue("sub_started_on", date ? date : null);
              setCreateConfirmDetailsToDisplay({
                ...createConfirmDetailsToDisplay,
                sub_started_on: dateString,
              });
            }}
          />

          <SelectField
            name="language"
            label={t("machinelicenses.create.form.language")}
            options={cultures.map((culture) => {
              return {
                label: culture.name,
                value: culture.code,
              };
            })}
            showSearch
            optionFilterProp="label"
            info={t("machinelicenses.create.form.languageinfo")}
            onChange={(value: string, obj: DropDownValueLabelObj) => {
              callBackForLanguage(value, obj);
            }}
          />

          <DrawerFooterContent>
            <Row justify="end">
              <Button
                style={{ minWidth: "80px" }}
                key="add-user-button"
                type="primary"
                onClick={onClickNext}
              >
                {t("machinelicenses.buttons.next")}
              </Button>
            </Row>
          </DrawerFooterContent>
        </VerticalForm>
      </div>
    </>
  );
};
